<app-tabla
  [totalCount]="totalCount"
  [datos]="trackeos"
  [columnas]="columnas"
  [name]="name"
  [pageSizeOptions]="helper.pageSizeOptions"
  [(query)]="query"
  (queryChange)="listar()"
  [paginatorArriba]="false"
  [emptyState]="{ title: 'Todavía no hay trackeos', subtitle: 'Acá aparecen las paradas por las que pasó el colectivo.' }"
></app-tabla>
